import React, { useState } from 'react';

const InvestmentCalculator = () => {
    const [amount, setAmount] = useState(1000000);
    const [years, setYears] = useState(5);

    const briqRate = 14;
    const mfRate = 12;
    const fdRate = 7;

    const calcReturns = (principal, rate, time) => {
        return Math.round(principal * Math.pow(1 + rate / 100, time));
    };

    const formatINR = (num) => {
        return num.toLocaleString('en-IN');
    };

    const briqReturns = calcReturns(amount, briqRate, years);
    const mfReturns = calcReturns(amount, mfRate, years);
    const fdReturns = calcReturns(amount, fdRate, years);
    const extraGain = briqReturns - fdReturns;

    return (
        <section className="investment-calculator" id="investment-calculator">
            <h2>Invest with BRIQ Construction</h2>
            <p>See how property investment outperforms traditional options</p>

            <div className="calculator-layout">
                {/* ── LEFT COLUMN ── */}
                <div className="calculator-left-col">
                    <div className="calculator-section">
                        <div className="calculator-section-title">Investment Calculator</div>
                        <p>Enter amount & duration to compare returns</p>

                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="form-group">
                                <label>Investment Amount (₹)</label>
                                <input
                                    type="number"
                                    value={amount}
                                    onChange={(e) => setAmount(Number(e.target.value))}
                                    placeholder="e.g. 1000000"
                                />
                            </div>
                            <div className="form-group">
                                <label>Investment Period (Years)</label>
                                <input
                                    type="number"
                                    value={years}
                                    onChange={(e) => setYears(Number(e.target.value))}
                                    placeholder="e.g. 5"
                                />
                            </div>
                            <button type="submit">Calculate Returns</button>
                        </form>
                    </div>

                    {/* Comparison Cards */}
                    <div className="comparison-cards">
                        <div className="comparison-card briq-card">
                            <span className="cc-icon">🏗️</span>
                            <span className="cc-label">Property (BRIQ)</span>
                            <span className="cc-value">₹{formatINR(briqReturns)}</span>
                            <span className="cc-rate">{briqRate}% p.a.</span>
                        </div>
                        <div className="comparison-card">
                            <span className="cc-icon">📈</span>
                            <span className="cc-label">Mutual Funds</span>
                            <span className="cc-value">₹{formatINR(mfReturns)}</span>
                            <span className="cc-rate">{mfRate}% p.a.</span>
                        </div>
                        <div className="comparison-card">
                            <span className="cc-icon">🏦</span>
                            <span className="cc-label">Fixed Deposit</span>
                            <span className="cc-value">₹{formatINR(fdReturns)}</span>
                            <span className="cc-rate">{fdRate}% p.a.</span>
                        </div>
                    </div>

                    {/* Additional Gain Banner */}
                    <div className="additional-gain-banner">
                        <div className="ag-left">
                            <span className="ag-label">Additional Gain with Property</span>
                            <span className="ag-sub">vs Fixed Deposit over {years} yrs</span>
                        </div>
                        <span className="ag-value">+₹{formatINR(extraGain)}</span>
                    </div>
                </div>

                {/* ── RIGHT COLUMN ── */}
                <div className="investment-why-panel">
                    <h3>Why Property Investment Wins</h3>
                    <span className="why-subtitle">
                        Real estate consistently outperforms traditional investment options. Here's why smart investors choose property.
                    </span>

                    <div className="why-points">
                        <div className="why-point">
                            <div className="why-point-icon">📈</div>
                            <div className="why-point-text">
                                <span className="wp-title">Higher Returns</span>
                                <span className="wp-desc">Property delivers 12–16% annual returns, beating FDs and most mutual funds consistently.</span>
                            </div>
                        </div>
                        <div className="why-point">
                            <div className="why-point-icon">🛡️</div>
                            <div className="why-point-text">
                                <span className="wp-title">Inflation Protection</span>
                                <span className="wp-desc">Real estate values rise with inflation, keeping your wealth safe from currency depreciation.</span>
                            </div>
                        </div>
                        <div className="why-point">
                            <div className="why-point-icon">🏠</div>
                            <div className="why-point-text">
                                <span className="wp-title">Tangible Asset</span>
                                <span className="wp-desc">Unlike stocks or funds, property is a physical asset you can see, use, and control.</span>
                            </div>
                        </div>
                        <div className="why-point">
                            <div className="why-point-icon">💰</div>
                            <div className="why-point-text">
                                <span className="wp-title">Rental Income</span>
                                <span className="wp-desc">Earn steady monthly passive income through rent while the property appreciates in value.</span>
                            </div>
                        </div>
                        <div className="why-point">
                            <div className="why-point-icon">📋</div>
                            <div className="why-point-text">
                                <span className="wp-title">Tax Benefits</span>
                                <span className="wp-desc">Save significantly on taxes with deductions on home loan interest and principal repayment.</span>
                            </div>
                        </div>
                        <div className="why-point">
                            <div className="why-point-icon">🏗️</div>
                            <div className="why-point-text">
                                <span className="wp-title">Wealth for Generations</span>
                                <span className="wp-desc">Property is a legacy asset that grows in value and can be passed down to future generations.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InvestmentCalculator;